import { frontendURL } from 'dashboard/helper/URLHelper';

const PERMISSIONS = ['administrator', 'agent', 'custom_role'];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/custom-settings'),
    name: 'custom_settings',
    meta: { permissions: PERMISSIONS },
    component: () => import('./CustomSettingsView.vue'),
  },
];
